import React from 'react'

interface ArrowUpTipOpenProps {
  size?: number
  color?: string
}

export const ArrowUpTipOpen: React.FC<ArrowUpTipOpenProps> = ({
  size = 16,
  color = '#fff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.665 5.219v7.448a.667.667 0 11-1.334 0V5.219L4.227 8.324a.667.667 0 11-.943-.943L7.29 3.374a1 1 0 011.414 0l4.007 4.007a.667.667 0 11-.943.943L8.665 5.219z"
        fill={color}
      />
    </svg>
  )
}
